export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

export interface ApiMethod {
  methodName: string;
  endpoint: string;
  method: HttpMethod;
}

export const API_METHODS: ApiMethod[] = [
  {
    methodName: 'getAnnouncement',
    endpoint: '/announcements',
    method: 'GET',
  },
  {
    methodName: 'createAnnouncement',
    endpoint: '/announcements',
    method: 'POST',
  },
  {
    methodName: 'authPassword',
    endpoint: '/oauth/token',
    method: 'POST',
  },
  {
    methodName: 'resetPassword',
    endpoint: '/users/password.json',
    method: 'POST',
  },
  {
    methodName: 'confirmPassword',
    endpoint: '/users/password.json',
    method: 'PATCH',
  },
  {
    methodName: 'confirmEmail',
    endpoint: '/users/confirmation',
    method: 'GET',
  },
  {
    methodName: 'createUser',
    endpoint: '/users.json',
    method: 'POST',
  },
  {
    methodName: 'invitation',
    endpoint: '/users/invitation.json',
    method: 'PUT',
  },
  {
    methodName: 'connectWithProvider',
    endpoint: '/users/auth/{provider}/callback',
    method: 'POST',
  },
  {
    methodName: 'getEmail',
    endpoint: '/emails',
    method: 'GET',
  },
  {
    methodName: 'upgradeAccount',
    endpoint: '/users/{userId}/{endpoint}',
    method: 'POST',
  },
  {
    methodName: 'getUpgradeAccountPlan',
    endpoint: '/users/{userId}/upgrade',
    method: 'GET',
  },
  {
    methodName: 'getProfile',
    endpoint: '/users/me',
    method: 'GET',
  },
  {
    methodName: 'getLibrary',
    endpoint: '/users/{userId}/collections/library',
    method: 'GET',
  },
  {
    methodName: 'getClients',
    endpoint: '/users/{userId}/collections/clients',
    method: 'GET',
  },
  {
    methodName: 'getArchivedClients',
    endpoint: '/users/{userId}/collections/clients/archived',
    method: 'GET',
  },
  {
    methodName: 'archiveClient',
    endpoint: '/clients/{clientId}/archive',
    method: 'PATCH',
  },
  {
    methodName: 'restoreClient',
    endpoint: '/clients/{clientId}/unarchive',
    method: 'PATCH',
  },
  {
    methodName: 'moveToGroup',
    endpoint: '/client_groups/{groupId}/members/{clientId}',
    method: 'POST',
  },
  {
    methodName: 'deleteFromGroup',
    endpoint: '/client_groups/{groupId}/members/{clientId}',
    method: 'DELETE',
  },
  {
    methodName: 'getGroupAssignment',
    endpoint: '/client_groups/{groupId}/assignments/{type}{status}',
    method: 'GET',
  },
  {
    methodName: 'createAssignment',
    endpoint: '/{type}/{id}/assignments/{endpoint}',
    method: 'POST',
  },
  {
    methodName: 'deleteAssignment',
    endpoint: '/{type}/{id}/assignments/{endpoint}',
    method: 'DELETE',
  },
  {
    methodName: 'archiveAssignment',
    endpoint: '/{type}/{id}/assignments/archive',
    method: 'PATCH',
  },
  {
    methodName: 'restoreAssignment',
    endpoint: '/{type}/{id}/assignments/unarchive',
    method: 'PATCH',
  },
  {
    methodName: 'getPersonalEntity',
    endpoint: '/users/{userId}/collections/{type}',
    method: 'GET',
  },
  {
    methodName: 'getArchivedPersonalEntity',
    endpoint: '/users/{userId}/collections/{type}/archived',
    method: 'GET',
  },
  {
    methodName: 'getClientGroups',
    endpoint: '/users/{userId}/collections/client_groups',
    method: 'GET',
  },
  {
    methodName: 'getPersonalProperties',
    endpoint: '/users/{userId}/collections/personal_properties',
    method: 'GET',
  },
  {
    methodName: 'getPersonalWorkouts',
    endpoint: '/users/{userId}/collections/personal_workouts',
    method: 'GET',
  },
  {
    methodName: 'getWorkoutEvents',
    endpoint: '/users/{userId}/collections/workout_events',
    method: 'GET',
  },
  {
    methodName: 'getWorkoutEvent',
    endpoint: '/workout_events/{id}',
    method: 'GET',
  },
  {
    methodName: 'getPros',
    endpoint: '/users/{userId}/collections/pros',
    method: 'GET',
  },
  {
    methodName: 'postPros',
    endpoint: '/pros',
    method: 'POST',
  },
  {
    methodName: 'getFullWorkoutEvent',
    endpoint: '/workout_events/{id}/full',
    method: 'GET',
  },
  {
    methodName: 'getClientsPerformance',
    endpoint: '/clients_performance',
    method: 'GET',
  },
  {
    methodName: 'getDashboards',
    endpoint: '/dashboards/{type}',
    method: 'GET',
  },
  {
    methodName: 'dismissAnnouncement',
    endpoint: '/dashboards/client/remove_announcement',
    method: 'DELETE',
  },
  {
    methodName: 'createFolder',
    endpoint: '/folders',
    method: 'POST',
  },
  {
    methodName: 'updateFolder',
    endpoint: '/folders/{id}',
    method: 'PATCH',
  },
  {
    methodName: 'uploadGroupAvatar',
    endpoint: '/client_groups/{groupId}/avatar',
    method: 'PATCH',
  },
  {
    methodName: 'uploadClientAvatar',
    endpoint: '/user_profile/{clientProfileId}/avatar',
    method: 'PATCH',
  },
  {
    methodName: 'createEntity',
    endpoint: '/{type}',
    method: 'POST',
  },
  {
    methodName: 'getEntity',
    endpoint: '/{type}/{id}',
    method: 'GET',
  },
  {
    methodName: 'updateEntity',
    endpoint: '/{type}/{id}',
    method: 'PATCH',
  },
  {
    methodName: 'deleteEntity',
    endpoint: '/{type}/{id}',
    method: 'DELETE',
  },
  {
    methodName: 'getEntityInternals',
    endpoint: '/{type}/{id}/{endpoint}',
    method: 'GET',
  },
  {
    methodName: 'duplicateEntity',
    endpoint: '/{type}/duplicate',
    method: 'POST',
  },
  {
    methodName: 'duplicateEntityItem',
    endpoint: '/{type}/{id}/duplicate',
    method: 'POST',
  },
  {
    methodName: 'createEntityItems',
    endpoint: '/{type}/{id}/items',
    method: 'POST',
  },
  {
    methodName: 'archiveClientEntity',
    endpoint: '/{type}/{id}/archive',
    method: 'PATCH',
  },
  {
    methodName: 'restoreClientEntity',
    endpoint: '/{type}/{id}/unarchive',
    method: 'PATCH',
  },
  {
    methodName: 'saveAsTemplate',
    endpoint: '/{type}/{id}/save_as_template',
    method: 'POST',
  },
  {
    methodName: 'inviteUser',
    endpoint: '/users/{userId}/invite',
    method: 'POST',
  },
  {
    methodName: 'getProductOrPlanBySlug',
    endpoint: '/{type}/by_slug/{slug}',
    method: 'GET',
  },
  {
    methodName: 'getProductPlansByNamespace',
    endpoint: '/product_plans',
    method: 'GET',
  },
  {
    methodName: 'getVideos',
    endpoint: '/videos',
    method: 'GET',
  },
  {
    methodName: 'uploadVideo',
    endpoint: '/videos',
    method: 'POST',
  },
  {
    methodName: 'searchVideo',
    endpoint: '/videos/search',
    method: 'GET',
  },
  {
    methodName: 'searchQuery',
    endpoint: '/search',
    method: 'GET',
  },
  {
    methodName: 'getSubscriptionPlans',
    endpoint: '/subscription_plans',
    method: 'GET',
  },
  {
    methodName: 'getCustomer',
    endpoint: '/users/{userId}/customer',
    method: 'GET',
  },
  {
    methodName: 'setSubscription',
    endpoint: '/subscriptions',
    method: 'POST',
  },
  {
    methodName: 'setProSubscription',
    endpoint: '/subscriptions/pro_subscriptions',
    method: 'POST',
  },
  {
    methodName: 'updateSubscription',
    endpoint: '/subscriptions/{id}',
    method: 'PATCH',
  },
  {
    methodName: 'cancelSubscription',
    endpoint: '/subscriptions/{id}',
    method: 'DELETE',
  },
  {
    methodName: 'checkCoupon',
    endpoint: '/subscriptions/validate_coupon',
    method: 'POST',
  },
  {
    methodName: 'setDefaultCard',
    endpoint: '/cards/{cardId}/default',
    method: 'PATCH',
  },
  {
    methodName: 'addCard',
    endpoint: '/cards/{token}',
    method: 'PATCH',
  },
  {
    methodName: 'deleteCard',
    endpoint: '/cards/{cardId}',
    method: 'DELETE',
  },
  {
    methodName: 'getUserTransactions',
    endpoint: '/users/{userId}/collections/transactions',
    method: 'GET',
  },
  {
    methodName: 'getLastFailedInvoice',
    endpoint: '/subscriptions/{subscriptionId}/last_failed_invoice',
    method: 'GET',
  },
  {
    methodName: 'paymentAttempt',
    endpoint: '/subscriptions/{subscriptionId}/last_failed_invoice/{invoiceID}',
    method: 'PATCH',
  },
  {
    methodName: 'getInvoices',
    endpoint: '/invoices',
    method: 'GET',
  },
  {
    methodName: 'createInvoice',
    endpoint: '/stripe/invoices',
    method: 'POST',
  },
  {
    methodName: 'getPaymentMethods',
    endpoint: '/stripe/payment_methods',
    method: 'GET',
  },
  {
    methodName: 'createPaymentMethod',
    endpoint: '/stripe/payment_methods',
    method: 'POST',
  },
  {
    methodName: 'deletePaymentMethod',
    endpoint: '/stripe/payment_methods/{id}',
    method: 'DELETE',
  },
  {
    methodName: 'defaultPaymentMethod',
    endpoint: '/stripe/payment_methods/{id}/default',
    method: 'PATCH',
  },
  {
    methodName: 'getPaymentIntents',
    endpoint: '/stripe/payment_intents',
    method: 'GET',
  },
  {
    methodName: 'setupPaymentIntent',
    endpoint: '/stripe/payment_intents/setup',
    method: 'POST',
  },
  {
    methodName: 'createPaymentIntent',
    endpoint: '/stripe/payment_intents',
    method: 'POST',
  },
  {
    methodName: 'finishPaymentIntent',
    endpoint: '/stripe/payment_intents/{id}',
    method: 'PATCH',
  },
  {
    methodName: 'stripeConnect',
    endpoint: '/users/auth/stripe_connect/callback',
    method: 'GET',
  },
  {
    methodName: 'getConversations',
    endpoint: '/conversations/{type}',
    method: 'GET',
  },
  {
    methodName: 'markMessageAsRead',
    endpoint: '/messages/{id}/read',
    method: 'PATCH',
  },
  {
    methodName: 'getAppNamespace',
    endpoint: '/app_namespaces/{symbol}',
    method: 'GET',
  },
  {
    methodName: 'getUserNamespace',
    endpoint: '/user_namespaces/{symbol}',
    method: 'GET',
  },
  {
    methodName: 'fetchClientNotes',
    endpoint: '/notes',
    method: 'GET',
  },
  {
    methodName: 'createClientNotes',
    endpoint: '/notes',
    method: 'POST',
  },
  {
    methodName: 'updateClientNotes',
    endpoint: '/notes/{id}',
    method: 'PATCH',
  },
  {
    methodName: 'deleteClientNotes',
    endpoint: '/notes/{id}',
    method: 'DELETE',
  },
];
